import { getSectorInfo } from '../../helpers/meetstandaard/sectorCatalog'

/**
 * Sectorkeuze boven een lijst.
 *
 * Verschijnt pas vanaf twee sectoren: een keuzelijst met één optie is
 * decoratie, en hij staat dan alleen maar in de weg. Gedeeld door Inzichten en
 * Benchmarks, zodat die twee niet elk hun eigen versie krijgen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {object} props
 * @param {string} props.id - Uniek id, want beide tabbladen kunnen tegelijk in de DOM staan
 * @param {Array<string>} props.sectors - Sector-slugs die in de gegevens voorkomen
 * @param {string} props.value - Gekozen slug, of '' voor alle
 * @param {(slug: string) => void} props.onChange - Aangeroepen bij een keuze
 */
const SectorFilter = ({ id, sectors, value, onChange }) => {
    if (!Array.isArray(sectors) || sectors.length < 2) return null

    return (
        <div className="intelligence-agenda__filter">
            <label htmlFor={id}>Sector</label>
            <select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
                <option value="">Alle sectoren</option>
                {sectors.map((slug) => (
                    <option key={slug} value={slug}>{getSectorInfo(slug)?.label || slug}</option>
                ))}
            </select>
        </div>
    )
}

export default SectorFilter
